export default __webpack_public_path__ + "static/media/Snd12.1a01ede6.mp3";